@if (viewModel$ | async; as vm) {
  <app-sidebar-room-card *ngFor="let room of vm.filteredRooms" [room]="room"></app-sidebar-room-card>
}
